export default "__VITE_ASSET__147ef480__"